module.exports = __webpack_public_path__ + "static/img/img2.64287a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img2.png
// module id = kpLa
// module chunks = 1